import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshTimerService {
  private intervalSubject = new Subject<void>();
  interval$: Observable<void> = this.intervalSubject.asObservable();
  timerId : any= null;
  constructor() {}

  startTimer(interval: number) {
    this.timerId = setInterval(() => {
      this.intervalSubject.next();
    }, interval);
  }

  stopTimer() {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
}
